module.exports = __webpack_public_path__ + "img/Superb_sword_11.dce5ab67.png";